export default "__VITE_ASSET__DkX4Dl_a__"